module.exports = __webpack_public_path__ + "static/media/GooglePlay.9b41763f.svg";